import { render } from "./Fase3Page.vue?vue&type=template&id=070b0390&scoped=true"
const script = {}

import "./Fase3Page.vue?vue&type=style&index=0&id=070b0390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070b0390"]])

export default __exports__